import { KsService } from '@siclop/kstone-vue'

export class SalaryGridLevelService extends KsService {
  protected static mainUrl = '/salary-grid-levels'
}
